exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr10[data-v-09ea931c]{margin-right:10px}.delete-tip[data-v-09ea931c]{font-size:14px;line-height:1.6;color:#303133}.status-time[data-v-09ea931c]{margin-top:4px;font-size:12px;color:#909399;line-height:1.4}.wrap-text[data-v-09ea931c]{word-break:break-all;white-space:normal}", ""]);

// exports
